import * as RadixDialog from '@radix-ui/react-dialog';
import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ActionSheetOverlayProps = RadixDialog.DialogOverlayProps;

export const ActionSheetOverlay = memo(({ className, ...restOfProps }: ActionSheetOverlayProps) => {
  return (
    <RadixDialog.Overlay
      className={cn('fixed inset-0 z-portal bg-black/60', className)}
      data-testid="ACTION_SHEET_OVERLAY"
      {...restOfProps}
    />
  );
});

ActionSheetOverlay.displayName = 'ActionSheetOverlay';
